export default (props, vars) => props?.['step'] || 1;
